<template>
  <div id="document-manager" class="relative overflow-hidden">
    <vs-sidebar
      class="items-no-padding"
      parent="#document-manager"
      :click-not-close="clickNotClose"
      :hidden-background="true"
      v-model="isSidebarActive"
    >
      <sidebar />
    </vs-sidebar>

    <div id="content-right" class="no-scroll-content">
      <div
        :class="{ 'sidebar-spacer': clickNotClose }"
        class="no-scroll-content border-r-0 border-t-0 border-b-0"
      >
        <content-header class="flex border d-theme-dark-bg items-center" />
        <content-view />
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from "./components/sidebar/DocumentSidebar";
import ContentHeader from "./components/content-header/DocumentContentHeader";
import ContentView from "./components/content-view/DocumentContentView";

import { createNamespacedHelpers } from "vuex";

const {
  mapActions: mapActionsOfenterpriseDocumentManager,
  mapMutations: mapMutationsOfenterpriseDocumentManager,
  mapState: mapStateOfenterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");


export default {
  name: "DocumentManager",
  components: {
    Sidebar,
    ContentHeader,
    ContentView
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapStateOfenterpriseDocumentManager([
      "isDocumentSidebarActive",
      "isDocumentSidebarClickNotClose",
      "documentRootPath"
    ]),
    isSidebarActive: {
      get () { return this.isDocumentSidebarActive },
      set (val) { this.SET_DOCUMENT_SIDEBAR_ACTIVE(val) }
    },
    clickNotClose: {
      get () { return this.isDocumentSidebarClickNotClose },
      set (val) { this.SET_DOCUMENT_SIDEBAR_CLICK_NOT_CLOSE(val) }
    },
    windowWidth () {
      return this.$store.state.windowWidth;
    }
  },
  methods: {

    ...mapActionsOfenterpriseDocumentManager([
      "fetchCurrentDocuments",
      "resetEnterpriseDocumentManagerState"
    ]),
    ...mapMutationsOfenterpriseDocumentManager([
      "SET_ENTERPRISE_ID",
      "SET_VESSEL_ID",
      "SET_DOCUMENT_ROOT_PATH",
      "SET_DOCUMENT_SIDEBAR_ACTIVE",
      "SET_DOCUMENT_SIDEBAR_CLICK_NOT_CLOSE",
      "SET_VESSEL_NAME",
      "SET_CURRENT_PATH",
      "SET_DOCUMENT_SEARCH",
      "SET_SEARCH_DOCUMENTS_RANGE"
    ]),
    setSidebarWidth () {
      if (this.windowWidth < 992) {
        this.isSidebarActive = false;
        this.clickNotClose = false;
      } else {
        this.isSidebarActive = true;
        this.clickNotClose = true;
      }
    },
    cleanup () {
      this.resetEnterpriseDocumentManagerState()
    },
    async setFolderPath () {
      //パスの設定
      const currentPath = this.$route.query.path
        .replace(this.documentRootPath, "")
        .split("/")
        .map(item => { return { name: item } });
      const fileName = currentPath.slice(-1)[0].name;
      currentPath.pop()
      this.SET_CURRENT_PATH(currentPath);
      this.SET_DOCUMENT_SEARCH(fileName);
      this.SET_SEARCH_DOCUMENTS_RANGE("current");
    },
  },
  watch: {
    windowWidth () {
      this.setSidebarWidth();
    },
    clickNotClose (val) {
      this.SET_DOCUMENT_SIDEBAR_CLICK_NOT_CLOSE(val)
    },
    isSidebarActive (val) {
      this.SET_DOCUMENT_SIDEBAR_ACTIVE(val)
    }
  },
  created () {
    const eId = this.$store.state.auth.user.id
    const vId = this.$route.params.vesselId
    this.SET_ENTERPRISE_ID(eId)
    this.SET_VESSEL_ID(vId)
    this.SET_DOCUMENT_ROOT_PATH(`e:${eId}/vessels/v:${vId}/`)
  },
  async mounted () {
    this.SET_VESSEL_NAME("船舶書類");
    if (this.$route.query.path) {
      await this.setFolderPath();
    }
    else {
      await this.fetchCurrentDocuments();
    }
  },
  destroyed () {
    this.cleanup();
  }
}

</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";

.vs-tooltip {
  overflow-wrap: break-word;
}

.vs-dialog-text {
  overflow-wrap: break-word;
}

#document-manager {
  border-radius: 5px;
  background: $aisea-pure-white;

  .vs-sidebar {
    z-index: 100;
    box-shadow: none;
    border-right: solid 1px $aisea-light-white;
  }
}
</style>

